module.exports = __webpack_public_path__ + "static/img/pic4.5847965.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case3/pic4.jpg
// module id = IBtK
// module chunks = 1